export default {
  'purchases.situation.OPEN': 'Aberta',
  'purchases.situation.AUTHORIZED': 'Autorizado',
  'purchases.situation.CANCELED': 'Cancelada',

  'purchases.list.header.code': 'Código',
  'purchases.list.header.company': 'Empresa',
  'purchases.list.header.provider': 'Fornecedor',
  'purchases.list.header.documentNumber': 'Nº Documento',
  'purchases.list.header.releaseDate': 'Dt. Lançamento',
  'purchases.list.header.situation': 'Situação',
  'purchases.list.header.boschStatus': 'Status envio Bosch',
  'purchases.list.header.actions': 'Ações',
  'purchases.list.column.actions.details': 'Ver/Editar',

  'purchases.searchBar.create': 'Nova Compra',
  'purchases.create.general': 'Geral',

  'purchases.situation': 'Situação: ',
  'purchases.newPurchase': 'Nova Compra',
  'purchases.sendEmail': 'Enviar E-mail',
  'purchases.sendEmail.modal.form.title': 'Enviar E-mail',
  'purchases.sendEmail.modal.form.for': 'Para:',
  'purchases.sendEmail.modal.form.subject': 'Assunto:',
  'purchases.sendEmail.modal.form.message': 'Mensagem',
  'purchases.printOut': 'Imprimir',
  'purchases.calculateTaxes': 'Calcular Tributos',
  'purchases.authorizePurchase': 'Autorizar Compra',
  'purchases.cancelPurchase': 'Cancelar Compra',

  'purchases.releases.form.code': 'Código',
  'purchases.releases.form.company': 'Empresa',
  'purchases.releases.form.invoiceKey': 'Chave Nota Fiscal',
  'purchases.releases.form.supplier': 'Fornecedor',
  'purchases.releases.form.add.supplier': 'Cadastrar Fornecedor',
  'purchases.releases.form.releaseDate': 'Dt. Lanc.',
  'purchases.releases.form.issuanceDate': 'Dt. Emissão',
  'purchases.releases.form.departureDate': 'Dt. Saída',
  'purchases.releases.form.noteTemplate': 'Modelo da Nota',
  'purchases.releases.form.series': 'Série',
  'purchases.releases.form.operationDestination': 'Destino Operação',
  'purchases.releases.form.internalOperation': '1 - Operação Interna',
  'purchases.releases.form.interstateOperation': '2 - Operação Interestadual',
  'purchases.releases.form.foreignOperation': '3 - Operação com Exterior',
  'purchases.releases.form.documentNumber': 'Número do Documento',
  'purchases.releases.form.shippingType': 'Tipo do Frete',
  'purchases.releases.form.recipient': 'Destinatário',
  'purchases.releases.form.issuer': 'Emitente',
  'purchases.releases.form.freeShipping': 'Sem Frete',
  'purchases.releases.form.the3rd': 'Terceiros',
  'purchases.releases.form.documentType': 'Tipo de Documento',
  'purchases.releases.form.additionalData': 'Dados Adicionais',
  'purchases.releases.form.invoiceFreight': 'NF. Frete',
  'purchases.releases.form.shippingValue': 'Valor Frete (R$)',
  'purchases.releases.form.expenditure': 'Despesas (R$)',
  'purchases.releases.form.discountValue': 'Valor Desconto (R$)',
  'purchases.releases.form.amount': 'Valor Total (R$)',
  'purchases.releases.form.includeIcms':
    'Frete, Despesas entram na base de cálculo ICMS ST',
  'purchases.releases.form.includeIpi':
    'Frete, Despesas entram na base de cálculo IPI',
  'purchases.releases.form.icmsDishonored':
    'Deduzir ICMS Desonerado do total da Nota Fiscal',
  'purchases.releases.form.expensesIndividually':
    'Inserir despesas individualmente',
  'purchases.releases.form.expensesIndividually.info':
    'Ao marcar esta opção, os valores de outras despesas ' +
    'devem ser informados diretamente nos itens da compra. ' +
    'Após salvar a compra, não é possível alterar esta opção.',

  'purchases.btn.authorize.confirm.title': 'Confirmação',
  'purchases.btn.authorize.confirm.content':
    'Deseja autorizar a compra e atualizar os preços dos itens? Os preços serão ajustados apenas no estoque',
  'purchases.btn.authorize.modal.authorizeChange': 'Autorizar e alterar preços',
  'purchases.btn.authorize.modal.authorize': 'Autorizar e não alterar preços',

  'purchases.details.itemsPurchase.selectPart': 'Selecione uma Peça',
  'purchases.details.itemsPurchase.selectConsumable': 'Selecione um Insumo',
  'purchases.details.itemsPurchase.selectService': 'Selecione um Serviço',
  'purchases.details.itemsPurchase.selectItemsOS': 'Selecione Itens O.S',
  'purchases.details.itemsPurchase.table.budget': 'Orçamento',
  'purchases.details.itemsPurchase.table.manufacturerCode': 'Cód. Fabricante',
  'purchases.details.itemsPurchase.table.description': 'Descrição',
  'purchases.details.itemsPurchase.table.manufacturer': 'Fabricante',
  'purchases.details.itemsPurchase.table.qty': 'Qtde.',
  'purchases.details.itemsPurchase.table.unitPrice': 'Pr. Unit.',
  'purchases.details.itemsPurchase.table.discount': 'Desc.',
  'purchases.details.itemsPurchase.table.amount': 'Vr. Total',
  'purchases.details.itemsPurchase.create.description': 'Descrição',
  'purchases.details.itemsPurchase.create.itemNumber': 'Nº item',
  'purchases.details.itemsPurchase.create.manufacturer': 'Fabricante',
  'purchases.details.itemsPurchase.create.ncm': 'NCM',
  'purchases.details.itemsPurchase.create.cfop': 'CFOP',
  'purchases.details.itemsPurchase.create.unit': 'Unidade',
  'purchases.details.itemsPurchase.create.quantity': 'Quantidade',
  'purchases.details.itemsPurchase.create.unitPrice': 'Preço Unitário',
  'purchases.details.itemsPurchase.create.discountValue': 'Valor Desconto',
  'purchases.details.itemsPurchase.create.amount': 'Valor Total',
  'purchases.details.itemsPurchase.create.expenses': 'Despesas',

  'purchases.items.part.tabOne.general': 'Geral',
  'purchases.items.task.issqn': 'ISSQN',
  'purchases.items.part.tabTwo.icms': 'ICMS',
  'purchases.items.part.tabThree.ipi': 'IPI',
  'purchases.items.task.irpjAndCsll': 'IRPJ/CSLL',
  'purchases.items.part.tabFour.pis': 'PIS',
  'purchases.items.part.tabFive.cofins': 'COFINS',
  'purchases.items.part.tabSix.icmsOperInter': 'ICMS OPER INTER',
  'purchases.items.part.tabSeven.iI': 'II',

  'purchases.details.itemsPurchase.issqn.quotaIssqn': 'Aliq. ISSQN',
  'purchases.details.itemsPurchase.issqn.baseIssqn': 'BC. ISSQN',
  'purchases.details.itemsPurchase.issqn.valueIssqn': 'Valor ISSQN',
  'purchases.details.itemsPurchase.irpjAndCsll.quotaIrpj': 'Aliq. IRPJ (%)',
  'purchases.details.itemsPurchase.irpjAndCsll.valueIrpj': 'Valor IRPJ',
  'purchases.details.itemsPurchase.irpjAndCsll.quotaCsll': 'Aliq. CSLL (%)',
  'purchases.details.itemsPurchase.irpjAndCsll.valueCsll': 'Valor CSLL',

  'purchases.details.itemsPurchase.icms.taxRegime': 'Regime Tributário',
  'purchases.details.itemsPurchase.icms.taxRegime.normalRegime':
    'Regime Normal',
  'purchases.details.itemsPurchase.icms.taxRegime.simpleNational':
    'Simples Nacional',
  'purchases.details.itemsPurchase.icms.taxRegime.simpleNationalExcess':
    'Simples Nacional com Excesso de Sublimite',
  'purchases.details.itemsPurchase.icms.taxRegime.cstIcms': 'CST ICMS',
  'purchases.details.itemsPurchase.icms.taxRegime.csosn': 'CSOSN',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms': 'Origem',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms.zero':
    '0 - Nacional, exceto as indicadas nos códigos 3, 4, 5 e 8',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms.one':
    '1 - Estrangeira - Importação direta, exceto a indicada no código 6',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms.two':
    '2 - Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms.three':
    '3 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40% e inferior ou igual a 70%',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms.four':
    '4 - Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam as legislações citadas nos Ajustes',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms.five':
    '5 - Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms.six':
    '6 - Estrangeira - Importação direta, sem similar nacional, constante em lista de CAMEX e gás natural',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms.seven':
    '7 - Estrangeira - Adquirida no mercado interno, sem similar nacial, constante lista CAMEX e  gás natural',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms.eight':
    '8 - Nacional, mercadoria',
  'purchases.details.itemsPurchase.icms.taxRegime.icms': 'ICMS',
  'purchases.details.itemsPurchase.icms.taxRegime.modBcIcms':
    'Modalidade de determinação da BC ICMS',
  'purchases.details.itemsPurchase.icms.taxRegime.modBcIcms.zero':
    '0 - Margem Valor Agregado (%)',
  'purchases.details.itemsPurchase.icms.taxRegime.modBcIcms.one':
    '1 - Pauta(Valor)',
  'purchases.details.itemsPurchase.icms.taxRegime.modBcIcms.two':
    '2 - Preço Tabelado Máx. (Valor)',
  'purchases.details.itemsPurchase.icms.taxRegime.modBcIcms.three':
    '3 - Valor da operação',
  'purchases.details.itemsPurchase.icms.taxRegime.reductionIcms':
    '(%) Redução BC ICMS',
  'purchases.details.itemsPurchase.icms.taxRegime.baseIcms': 'BC ICMS',
  'purchases.details.itemsPurchase.icms.taxRegime.quotaIcms': 'Alíq. ICMS',
  'purchases.details.itemsPurchase.icms.taxRegime.valueIcms': 'Valor ICMS',
  'purchases.details.itemsPurchase.icms.taxRegime.baseFcp': 'Base Cálculo FCP',
  'purchases.details.itemsPurchase.icms.taxRegime.quotaFcp': 'Alíquota FCP',
  'purchases.details.itemsPurchase.icms.taxRegime.valueFcp': 'Valor FCP',
  'purchases.details.itemsPurchase.icms.taxRegime.valueIcmsUnencumbered':
    'Valor ICMS desonerado',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms':
    'Motivo da desoneração do ICMS',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.one': '1 - Táxi',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.three':
    '3 - Uso na agropecuaria',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.four':
    '4 - Frotista/Locadora',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.five':
    '5 - Diplomático/Consular',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.six':
    '6 - Utilitários e Motocicletas da Amazônia Ocidental e Áreas de Livre Comércio (Resolução 714/88 e 790/94 - CONTRAN e suas alterações)',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.seven':
    '7 - SUFRAMA',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.eigth':
    '8 - Venda a Órgão Público',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.nine':
    '9 - Outros',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.ten':
    '10 - Deficiente Condutor (Convênio ICMS 38/12)',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.eleven':
    '11 - Deficiente Não Condutor (Convênio ICMS 38/12)',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.twelven':
    '12 - Orgão de fomento e desenvolvimento agropecuário',
  'purchases.details.itemsPurchase.icmsSt.taxRegime': 'ICMS ST',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt':
    'Modalidade de determinação da BC ICMS ST',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt.zero':
    '0 - Preço tabelado ou máximo sugerido',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt.one':
    '1 - Lista Negativa (valor)',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt.two':
    '2 - Lista Positiva (valor)',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt.three':
    '3 - Lista Neutra (valor)',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt.four':
    '4 - Margem Valor Agregado (%)',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt.five':
    '5 - Pauta (valor)',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.reductionIcmsSt':
    '(%) Redução BC ICMS ST',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.baseIcmsSt': 'BC ICMS ST',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.quotaIcmsSt':
    'Alíq. ICMS ST',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.valueIcmsSt':
    'Valor ICMS ST',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.quotaMvaSt':
    '(%) Subst. Trib (MVA)',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.baseIcmsStWithheld':
    'BC ICMS ST retid.',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.valueIcmsStWithheld':
    'Valor ICMS ST retid.',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.baseFcpSt':
    'Base Cálculo FCP ST',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.quotaFcpSt':
    'Alíquota FCP ST',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.valueFcpSt': 'Valor FCP ST',

  'purchases.details.itemsPurchase.ipi.taxRegime.cstIpi': 'CST IPI',
  'purchases.details.itemsPurchase.ipi.taxRegime.quotaIpi': 'Alíq. IPI',
  'purchases.details.itemsPurchase.ipi.taxRegime.baseIpi': 'BC. IPI',
  'purchases.details.itemsPurchase.ipi.taxRegime.valueIpi': 'Valor IPI',

  'purchases.details.itemsPurchase.pis.taxRegime.title': 'PIS',
  'purchases.details.itemsPurchase.pis.taxRegime.cstPis': 'CST PIS',
  'purchases.details.itemsPurchase.pis.taxRegime.calcPercentPis':
    'Tipo de Cálculo',
  'purchases.details.itemsPurchase.pis.taxRegime.calcPercentPis.percentage':
    'Percentual',
  'purchases.details.itemsPurchase.pis.taxRegime.calcPercentPis.value': 'Valor',
  'purchases.details.itemsPurchase.pis.taxRegime.quotaPis': 'Aliq. PIS',
  'purchases.details.itemsPurchase.pis.taxRegime.basePis': 'BC. PIS',
  'purchases.details.itemsPurchase.pis.taxRegime.valueUnityPis':
    'Vlr. PIS por unidade',
  'purchases.details.itemsPurchase.pis.taxRegime.valuePis': 'Valor PIS',
  'purchases.details.itemsPurchase.pisSt.taxRegime.title': 'PIS ST',
  'purchases.details.itemsPurchase.pisSt.taxRegime.calcPercentPisSt':
    'Tipo de Cálculo',
  'purchases.details.itemsPurchase.pisST.taxRegime.quotaPisSt': 'Aliq. PIS ST',
  'purchases.details.itemsPurchase.pisST.taxRegime.valueUnityPisSt':
    'Vlr. PIS ST por unidade',
  'purchases.details.itemsPurchase.pisST.taxRegime.basePisSt': 'BC. PIS ST',
  'purchases.details.itemsPurchase.pisST.taxRegime.valuePisSt': 'Valor PIS ST',

  'purchases.details.itemsPurchase.cofins.taxRegime.title': 'COFINS',
  'purchases.details.itemsPurchase.cofins.taxRegime.cstCofins': 'CST COFINS',
  'purchases.details.itemsPurchase.cofins.taxRegime.quotaCofins':
    'Aliq. COFINS',
  'purchases.details.itemsPurchase.cofins.taxRegime.baseCofins': 'BC. COFINS',
  'purchases.details.itemsPurchase.cofins.taxRegime.calcPercentCofins':
    'Tipo de Cálculo',
  'purchases.details.itemsPurchase.cofins.taxRegime.valueUnityCofins':
    'Vlr. COFINS por unidade',
  'purchases.details.itemsPurchase.cofins.taxRegime.valueCofins':
    'Valor COFINS',
  'purchases.details.itemsPurchase.cofinsSt.taxRegime.title': 'COFINS ST',
  'purchases.details.itemsPurchase.cofinsSt.taxRegime.quotaCofinsSt':
    'Aliq. COFINS ST',
  'purchases.details.itemsPurchase.cofinsSt.taxRegime.valueUnityCofinsSt':
    'Vlr. COFINS ST por unidade',
  'purchases.details.itemsPurchase.cofinsSt.taxRegime.calcPercentCofinsSt':
    'Tipo de Cálculo',
  'purchases.details.itemsPurchase.cofinsSt.taxRegime.baseCofinsSt':
    'BC. COFINS ST',
  'purchases.details.itemsPurchase.cofinsSt.taxRegime.valueCofinsSt':
    'Valor COFINS ST',

  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.percentIcmsFcp':
    '(%)ICMS FCP',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.baseInterstateIcms':
    'BC ICMS Interestadual',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.quotaIcmsUfDestination':
    'Aliq. ICMS UF destino',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.quotaInterstateIcms':
    'Aliquota Interestadual',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.quotaInterstateIcms.zero':
    '4% alíquota interestadual para produtos importados',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.quotaInterstateIcms.one':
    '7% para os Estados de origem do Sul e Sudeste (exceto ES), destinado para os Estados do Norte, Nordeste, Centro-Oeste e Espírito Santo',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.quotaInterstateIcms.two':
    '12% para os demais casos.',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.percentProvisionalParticipation':
    '(%)Provisório partilha',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.percentProvisionalParticipation.zero':
    '40% em 2016',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.percentProvisionalParticipation.one':
    '60% em 2017',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.percentProvisionalParticipation.two':
    '80% em 2018',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.percentProvisionalParticipation.three':
    '100% a partir de 2019',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.valueInterstateDestinationIcms':
    'Valor ICMS destinatário',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.valueInterstateOriginIcms':
    'Valor ICMS remetente',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.valueIcmsFcp':
    'Valor ICMS FCP',

  'purchases.details.itemsPurchase.iI.taxRegime.valueBaseOfImportTax':
    'Valor da BC do Imposto de Importação',
  'purchases.details.itemsPurchase.iI.taxRegime.valueOfCustomsExpenses':
    'Valor das despesas aduaneiras',
  'purchases.details.itemsPurchase.iI.taxRegime.valueImportTax':
    'Valor do Imposto de Importação',
  'purchases.details.itemsPurchase.iI.taxRegime.amountOfTaxOnFinancialTransactions':
    'Valor do Imposto sobre Operações Financeiras',

  'purchases.details.itemsPurchase.notifications.remove.confirm.title':
    'Você deseja realmente excluir esse Item?',
  'purchases.details.itemsPurchase.notifications.remove.confirm.content':
    'Ao remover o Item, todas as informações serão perdidas permanentemente. Ainda sim deseja continuar?',
  'purchases.details.notifications.remove.success.title': 'Item removido',
  'purchases.details.notifications.remove.success.description':
    'O item foi removido com sucesso!',

  'purchase.details.taxes.form.icmsValue': 'Valor ICMS',
  'purchase.details.taxes.form.icmsStValue': 'Valor ICMS ST',
  'purchase.details.taxes.form.pisValue': 'Valor PIS',
  'purchase.details.taxes.form.pisStValue': 'Valor PIS ST',
  'purchase.details.taxes.form.ipiValue': 'Valor IPI',
  'purchase.details.taxes.form.cofinsValue': 'Valor COFINS',
  'purchase.details.taxes.form.cofinsStValue': 'Valor COFINS ST',
  'purchase.details.taxes.form.issqnValue': 'Valor ISSQN',
  'purchase.details.taxes.form.fcpValue': 'Valor FCP',
  'purchase.details.taxes.form.fcpStValue': 'Valor FCP ST',
  'purchase.details.taxes.form.bcValue': 'Valor da BC do Imposto de Importação',
  'purchase.details.taxes.form.expensesValue': 'Valor das despesas aduaneiras',
  'purchase.details.taxes.form.taxAmountValue':
    'Valor do Imposto de Importação',
  'purchase.details.taxes.form.transactionsFinancialValue':
    'Valor do Imposto sobre Operações Financeiras',

  'purchases.filters.workerOrderNumber': 'Número do Orçamento',
  'purchases.filters.company': 'Empresa',
  'purchases.filters.supplier': 'Fornecedor',
  'purchases.filters.documentNumber': 'Nº Documento',
  'purchases.filters.releaseDate': 'Dt. Lançamento',
  'purchases.filters.situation': 'Situação',

  'purchases.notifications.create.success.title': 'Sucesso!',
  'purchases.notifications.create.success.description':
    'A sua Compra foi criada com sucesso!',

  'purchases.notifications.update.success.title': 'Sucesso!',
  'purchases.notifications.update.success.description':
    'Sua compra foi atualizada com sucesso!',

  'purchases.notifications.remove.confirm.title':
    'Você deseja realmente excluir essa Compra?',
  'purchases.notifications.remove.confirm.content':
    'Ao remover a sua Compra, todas as informações serão perdidas permanentemente. Ainda sim deseja continuar?',
  'purchases.notifications.remove.success.title': 'Compra removida',
  'purchases.notifications.remove.success.description':
    'A Compra foi removida com sucesso!',

  'purchases.notifications.authorize.success.title': 'Compra autorizada',
  'purchases.notifications.authorize.success.description':
    'A Compra foi autorizada com sucesso!',

  'purchases.notifications.canceled.success.title': 'Compra cancelada',
  'purchases.notifications.canceled.success.description':
    'A Compra foi cancelada com sucesso!',
  'itemsPurchase.notifications.create.success.title': 'Sucesso!',
  'itemsPurchase.notifications.create.success.description':
    'O Item da sua Compra foi criado com sucesso!',

  'itemsPurchase.notifications.update.success.title': 'Sucesso!',
  'itemsPurchase.notifications.update.success.description':
    'O Item da sua Compra foi alterado com sucesso!',

  'itemsPurchase.notifications.calcTaxes.success.description':
    'Tributos do item compra calculado com sucesso!',

  'itemsPurchase.error.message.csosnIcms': 'CSOSN ICMS não informado',
};
